var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Urls } from "@lonelyplanet/dotcom-routing/dist/create";
import { createBreadcrumbFromPoi, createBreadcrumbsFromAncestry } from "../../../shared/utils/breadcrumb";
import _ from "../../../shared/utils/lodash";
import { getPlaceType } from "../../../shared/utils/slug";
import { getFullBodyText } from "../utils/getFullBodyText";
import hotelProvider from "../utils/hotelProvider";
var maxRelatedActivities = 3;
var maxRelatedTours = 3;
var DetailPageInitialState = /** @class */ (function () {
    function DetailPageInitialState(options) {
        this.poi = options.poi;
        this.location = options.location;
        this.related = options.related.slice(0, maxRelatedActivities);
        this.tour = options.tour.slice(0, maxRelatedTours);
        this.places = options.places;
        this.match = options.match;
        this.isMobile = options.isMobile;
        if (options.places) {
            this.breadcrumbs = createBreadcrumbsFromAncestry(this.places, this.poi).concat([
                createBreadcrumbFromPoi(this.poi, this.places),
            ]);
        }
        this.nearby = options.nearby;
        this.profileHost = options.profileHost;
        this.authHost = options.authHost;
    }
    Object.defineProperty(DetailPageInitialState.prototype, "meta", {
        get: function () {
            var _a = this.poi, descriptions = _a.descriptions, name = _a.name, providers = _a.providers, review = _a.review;
            var provider = providers && providers.length > 0 ? hotelProvider(providers) : {};
            var bodyText = getFullBodyText({
                descriptions: descriptions,
                provider: provider,
                review: review,
            });
            return {
                canonical: "https://www.lonelyplanet.com" + this.getCanonicalUrl(__assign({}, this.poi, { containingPlaceId: this.placeIdForCanonical(this.poi.containingPlaces) })),
                description: {
                    full: bodyText,
                    truncated: _.truncate(bodyText, {
                        length: 300,
                        omission: "…",
                    }),
                },
                title: "" + name,
            };
        },
        enumerable: true,
        configurable: true
    });
    DetailPageInitialState.prototype.getCanonicalUrl = function (poi) {
        return Urls.create(poi);
    };
    DetailPageInitialState.prototype.placeIdForCanonical = function (places) {
        var city = getPlaceType(this.poi.containingPlaces, "city");
        var country = getPlaceType(this.poi.containingPlaces, "country");
        var continent = getPlaceType(this.poi.containingPlaces, "continent");
        var place = city || country || continent;
        if (place) {
            return place.id;
        }
        return this.poi.containingPlaceId;
    };
    return DetailPageInitialState;
}());
export { DetailPageInitialState };



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/initialState/detailPageInitialState.ts
// module id = uXBU
// module chunks = 2